module.exports = __webpack_public_path__ + "static/media/Insight.ef872695.svg";